import React from 'react';

function ActivitySkeleton({ count = 5 }) {
    return (
        <div className="activity-skeleton">
            {Array.from({ length: count }).map((_, index) => (
                <div className="activity-skeleton__item" key={`activity-skeleton-${index}`}>
                    <div className="activity-skeleton__avatar"></div>
                    <div className="activity-skeleton__content">
                        <div className="activity-skeleton__line activity-skeleton__line--long flex-grow-1 mb-0"></div>
                        <div className="activity-skeleton__line activity-skeleton__line--short mb-0"></div>
                    </div>
                </div>
            ))}
        </div>
    );
}

export default ActivitySkeleton;
